import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { currencyTypes, outsourcePeriod } from 'utils/Constants'
import { useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { currencyFormatter } from '../../utils/CurrencyFormatter'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'
import Icons from '../../assets/icons'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputNumber } from 'primereact/inputnumber'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'
import { getPermission } from '../../utils/Auth'
import { InputTextarea } from 'primereact/inputtextarea'

const AddOutsourceModalContent = ({ handleClose, handleAdd, outsourceId }) => {
	const { projectId } = useParams()
	const [request, loading] = useRequest()
	const { showToast } = useToast()
	const [canCreateOutsource, setCanCreateOutsource] = useState()
	const [canUpdateOutsource, setCanUpdateOutsource] = useState()
	const [canDeleteOutsource, setCanDeleteOutsource] = useState()
	const [addForm, setAddForm] = useState({
		projectId: projectId,
		name: null,
		position: null,
		startDate: null,
		endDate: null,
		period: null,
		rate: null,
		rateCurrency: null,
	})
	const [rateModal, setRateModal] = useState({
		open: false,
		isEdit: false,
		data: [],
		form: {
			id: null,
			outsourceId: outsourceId,
			startDate: null,
			endDate: null,
			rate: null,
			currency: null,
		},
	})
	const [noteModal, setNoteModal] = useState({
		open: false,
		isEdit: false,
		data: [],
		form: {
			id: null,
			outsourceId: outsourceId,
			note: null,
		},
	})

	useEffect(() => {
		setCanCreateOutsource(getPermission('Outsource.create'))
		setCanUpdateOutsource(getPermission('Outsource.update'))
		setCanDeleteOutsource(getPermission('Outsource.delete'))

		getOutsource()
	}, [outsourceId])

	const getOutsource = () => {
		let id = addForm.id || outsourceId
		if (!id) return

		request(`/Outsource/GetOutsourceById`, { params: { id: id } }).then((res) => {
			if (res.data.ok) {
				setAddForm(res.data.result)
			}
		})
	}

	const handleChange = (e, name) => {
		if (name) {
			setAddForm((prev) => ({ ...prev, [name]: e }))
		} else {
			setAddForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}

	const handleSubmit = () => {
		if (!addForm.name) {
			showToast('Lütfen personel adını girin', 'error')
		} else if (!addForm.position) {
			showToast('Lütfen personel pozisyonunu girin', 'error')
		} else if (!addForm.startDate) {
			showToast('Lütfen başlangıç tarihini girin', 'error')
		} else if (addForm.period === null) {
			showToast('Lütfen periyodu girin', 'error')
		} else {
			request('/Outsource/UpsertOutsource', {
				method: 'PUT',
				data: addForm,
			}).then((res) => {
				if (res.data.ok) {
					if (outsourceId) {
						showToast('Personel güncellendi', 'success')
					} else {
						showToast('Personel eklendi', 'success')
					}
					handleClose()
					handleAdd()
				}
			})
		}
	}

	const handleRateFormChange = (e, name) => {
		if (name) {
			setRateModal((prev) => ({ ...prev, form: { ...prev.form, [name]: e } }))
		} else {
			setRateModal((prev) => ({ ...prev, form: { ...prev.form, [e.target.name]: e.target.value } }))
		}
	}

	const handleRateSubmit = () => {
		if (!rateModal.form.startDate) {
			showToast('Lütfen başlangıç tarihini girin', 'error')
		} else if (!rateModal.form.endDate) {
			showToast('Lütfen bitiş tarihini girin', 'error')
		} else if (!rateModal.form.rate) {
			showToast('Lütfen rate girin', 'error')
		} else if (!rateModal.form.currency) {
			showToast('Lütfen para birimi seçin', 'error')
		} else {
			request('/Outsource/UpsertOutsourceRate', {
				method: 'PUT',
				data: rateModal.form,
			}).then((res) => {
				if (res.data.ok) {
					if (rateModal.form.id) {
						showToast('Rate güncellendi', 'success')
					} else {
						showToast('Rate eklendi', 'success')
					}

					openRateModal()
					getOutsource()
					handleAdd()
				}
			})
		}
	}

	const openRateModal = () => {
		getOutsourceRates().then(() => {
			setRateModal((prev) => ({ ...prev, open: true, isEdit: false }))
		})
	}

	const getOutsourceRates = () => {
		return request('/Outsource/GetOutsourceRates', { params: { outsourceId: outsourceId } }).then((res) => {
			if (res.data.ok) {
				setRateModal((prev) => ({ ...prev, data: res.data.result }))
			}
		})
	}

	const rateDeleteButtonTemplate = (rowData) => {
		return (
			<Icons.deleteNotFill
				onClick={() => {
					confirmDialog({
						message: 'Kaydı silmek istiyor musunuz?',
						header: '',
						icon: 'pi pi-info-circle',
						acceptClassName: 'p-button-danger',
						accept: () => {
							request('/Outsource/DeleteOutsourceRate', {
								method: 'DELETE',
								data: { id: rowData.id },
							}).then((res) => {
								if (res.data.ok) {
									showToast('Rate silindi', 'success')
									getOutsourceRates()
									getOutsource()
								}
							})
						},
					})
				}}
				size={20}
				className='text-danger cursor-pointer'
			/>
		)
	}

	const handleNoteFormChange = (e, name) => {
		if (name) {
			setNoteModal((prev) => ({ ...prev, form: { ...prev.form, [name]: e } }))
		} else {
			setNoteModal((prev) => ({ ...prev, form: { ...prev.form, [e.target.name]: e.target.value } }))
		}
	}

	const handleNoteSubmit = () => {
		if (!noteModal.form.note) {
			showToast('Lütfen not girin', 'error')
		} else {
			request('/Outsource/UpsertOutsourceNote', {
				method: 'PUT',
				data: noteModal.form,
			}).then((res) => {
				if (res.data.ok) {
					if (noteModal.form.id) {
						showToast('Not güncellendi', 'success')
					} else {
						showToast('Not eklendi', 'success')
					}

					openNoteModal()
				}
			})
		}
	}

	const openNoteModal = () => {
		getOutsourceNotes().then(() => {
			setNoteModal((prev) => ({ ...prev, open: true, isEdit: false }))
		})
	}

	const getOutsourceNotes = () => {
		return request('/Outsource/GetOutsourceNotes', { params: { outsourceId: outsourceId } }).then((res) => {
			if (res.data.ok) {
				setNoteModal((prev) => ({ ...prev, data: res.data.result }))
			}
		})
	}

	const noteDeleteButtonTemplate = (rowData) => {
		return (
			<Icons.deleteNotFill
				onClick={() => {
					confirmDialog({
						message: 'Kaydı silmek istiyor musunuz?',
						header: '',
						icon: 'pi pi-info-circle',
						acceptClassName: 'p-button-danger',
						accept: () => {
							request('/Outsource/DeleteOutsourceNote', {
								method: 'DELETE',
								data: { id: rowData.id },
							}).then((res) => {
								if (res.data.ok) {
									showToast('Not silindi', 'success')
									getOutsourceNotes()
								}
							})
						},
					})
				}}
				size={20}
				className='text-danger cursor-pointer'
			/>
		)
	}

	return (
		<>
			<div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
				{addForm.id && (
					<>
						<div className='row'>
							<div className='col-md-12 d-flex justify-content-end align-items-center flex-wrap gap-3'>
								<Button className='btn-success' title='Notlar' handleClick={openNoteModal} />
								<Button className='btn-success' title='Rate Yönetimi' handleClick={openRateModal} />
							</div>
						</div>
						<hr className='divider my-md-1' />
					</>
				)}

				<div className='row'>
					<div className='col-md-12'>
						<div className='form-control'>
							<label className='text-bold'>Personel Adı</label>
							<input
								placeholder='Personel Adı'
								className='default-input'
								type='text'
								name='name'
								value={addForm.name}
								onChange={(e) => handleChange(e)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12'>
						<div className='form-control'>
							<label className='text-bold'>Pozisyon</label>
							<input
								placeholder='Pozisyon'
								className='default-input'
								type='text'
								name='position'
								value={addForm.position}
								onChange={(e) => handleChange(e)}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-6'>
						<div className='form-control'>
							<label className='text-bold'>Başlangıç Tarihi</label>
							<Calendar
								dateFormat='dd/mm/yy'
								placeholder='Başlangıç Tarihi'
								name='startDate'
								value={addForm.startDate && new Date(addForm.startDate)}
								onChange={(e) => {
									handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
								}}
							/>
						</div>
					</div>
					<div className='col-md-6'>
						<div className='form-control'>
							<label className='text-bold'>Bitiş Tarihi</label>
							<Calendar
								dateFormat='dd/mm/yy'
								placeholder='Bitiş Tarihi'
								name='endDate'
								value={addForm.endDate && new Date(addForm.endDate)}
								onChange={(e) => {
									handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
								}}
							/>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-6'>
						<div className='form-control'>
							<label className='text-bold'>Periyot</label>
							<DefaultSelect
								placeholder='Periyot'
								value={outsourcePeriod
									.map((pt) => ({ label: pt.type, value: pt.value }))
									.find((c) => c.value === addForm.period)}
								selectOptions={outsourcePeriod.map((pt) => ({ label: pt.type, value: pt.value }))}
								handleChange={(e) => handleChange(e?.value, 'period')}
							/>
						</div>
					</div>
					{addForm.id && (
						<div className='col-md-6'>
							<div className='form-control'>
								<label className='text-bold'>Güncel Rate</label>
								<input
									className='default-input'
									type='text'
									name='rate'
									disabled
									value={addForm.rate && `${currencyFormatter(addForm.rate)} ${addForm.rateCurrency}`}
								/>
							</div>
						</div>
					)}
				</div>
				<div className='row justify-content-center'>
					<div className='col-md-3'>
						<Button
							handleClick={handleSubmit}
							className='btn-success w-100 justify-content-center'
							title={'Kaydet'}
							disabled={loading}
						/>
					</div>
					<div className='col-md-3'>
						<Button
							handleClick={handleClose}
							className='btn-danger-outline w-100 justify-content-center'
							title={'Vazgeç'}
							disabled={loading}
						/>
					</div>
				</div>
			</div>

			<Dialog
				style={{ width: !rateModal.isEdit ? '700px' : '' }}
				header={rateModal.isEdit ? 'Rate Ekle / Düzenle' : addForm.name + ' Rate Listesi'}
				visible={rateModal.open}
				onHide={() => setRateModal((prev) => ({ ...prev, open: prev.isEdit, isEdit: false }))}
				draggable={false}
			>
				{!rateModal.isEdit ? (
					<div>
						<ConfirmDialog />
						<div className='card'>
							{canCreateOutsource && (
								<Button
									className='btn-primary btn-sm ml-auto'
									title='Rate Ekle'
									handleClick={() =>
										setRateModal((prev) => ({ ...prev, isEdit: true, form: { outsourceId: addForm.id } }))
									}
									icon={<Icons.plus />}
								/>
							)}
							<DataTable
								emptyMessage='Hiç Kayıt Bulunamadı'
								loading={loading}
								responsiveLayout='stack'
								value={rateModal.data}
								editMode='row'
								dataKey='id'
								rowClassName={'cursor-pointer table-hover'}
								onRowClick={(e) => {
									if (e.originalEvent.target.className.includes('p-button-icon')) return
									if (canUpdateOutsource && e.data.id) {
										setRateModal((prev) => ({ ...prev, isEdit: true, form: e.data }))
									}
								}}
							>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='startDate'
									header='Başlangıç Tarihi'
									style={{ width: 'auto' }}
									dataType='date'
									body={(rowData) => {
										const startDate = moment(rowData.startDate).format('LL')
										return <span>{startDate}</span>
									}}
								/>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='endDate'
									header='Bitiş Tarihi'
									sortable='true'
									style={{ width: 'auto' }}
									body={(rowData) => {
										const endDate = moment(rowData.endDate).format('LL')
										return <span>{endDate}</span>
									}}
								/>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='rate'
									header='Rate'
									sortable='true'
									style={{ width: 'auto' }}
									body={(rowData) => {
										return (
											<span>
												{currencyFormatter(rowData.rate)} {rowData.currency}
											</span>
										)
									}}
								/>
								<Column
									className='text-semi-bold'
									body={(rowData) => (
										<span className='d-flex gap-1'>{canDeleteOutsource && rateDeleteButtonTemplate(rowData)}</span>
									)}
									style={{ width: '2.5rem' }}
								/>
							</DataTable>
						</div>
					</div>
				) : (
					<div>
						<div className='card' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='field w-100'>
								<Calendar
									placeholder='Başlangıç Tarihi'
									id='icon'
									className='w-100'
									dateFormat='dd/mm/yy'
									tooltipOptions={{ position: 'top' }}
									value={rateModal.form.startDate && new Date(rateModal.form.startDate)}
									onChange={(e) => {
										handleRateFormChange(moment(e.target.value).add(3, 'hours').toISOString(), 'startDate')
									}}
									showIcon
								/>
							</div>
							<div className='field w-100'>
								<Calendar
									dateFormat='dd/mm/yy'
									placeholder='Bitiş Tarihi'
									id='icon'
									className='w-100'
									value={rateModal.form.endDate && new Date(rateModal.form.endDate)}
									onChange={(e) => {
										handleRateFormChange(moment(e.target.value).add(3, 'hours').toISOString(), 'endDate')
									}}
									showIcon
								/>
							</div>
							<div className='field w-100'>
								<InputNumber
									inputId='inputnumber'
									mode='decimal'
									minFractionDigits={2}
									placeholder='Rate'
									className='w-100'
									value={rateModal.form.rate}
									onChange={(e) => {
										handleRateFormChange(e.value, 'rate')
									}}
								/>
							</div>
							<div className='field w-100'>
								<Dropdown
									className='w-100'
									placeholder='Para Birimi'
									inputId='dropdown'
									options={currencyTypes}
									optionLabel='label'
									optionValue='value'
									value={rateModal.form.currency}
									onChange={(e) => {
										handleRateFormChange(e.value, 'currency')
									}}
								/>
							</div>
							<Button className='btn-bill w-100' title='Kaydet' handleClick={handleRateSubmit} />
							<Button
								className='btn-bill w-100'
								title='Vazgeç'
								handleClick={() => {
									setRateModal((prev) => ({ ...prev, isEdit: false }))
								}}
							/>
						</div>
					</div>
				)}
			</Dialog>

			<Dialog
				style={{ width: !noteModal.isEdit ? '900px' : '' }}
				header={noteModal.isEdit ? 'Not Ekle / Düzenle' : addForm.name + ' Not Listesi'}
				visible={noteModal.open}
				onHide={() => setNoteModal((prev) => ({ ...prev, open: prev.isEdit, isEdit: false }))}
				draggable={false}
			>
				{!noteModal.isEdit ? (
					<div>
						<ConfirmDialog />
						<div className='card'>
							{canCreateOutsource && (
								<Button
									className='btn-primary btn-sm ml-auto'
									title='Not Ekle'
									handleClick={() =>
										setNoteModal((prev) => ({ ...prev, isEdit: true, form: { outsourceId: addForm.id } }))
									}
									icon={<Icons.plus />}
								/>
							)}
							<DataTable
								emptyMessage='Hiç Kayıt Bulunamadı'
								loading={loading}
								responsiveLayout='stack'
								value={noteModal.data}
								editMode='row'
								dataKey='id'
								rowClassName={'cursor-pointer table-hover'}
								onRowClick={(e) => {
									if (e.originalEvent.target.className.includes('p-button-icon')) return
									if (canUpdateOutsource && e.data.id) {
										setNoteModal((prev) => ({ ...prev, isEdit: true, form: e.data }))
									}
								}}
							>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='createdAt'
									header='Tarih'
									style={{ width: '10rem' }}
									dataType='date'
									sortable='true'
									body={(rowData) => {
										const date = rowData.updatedAt
											? moment(rowData.updatedAt).format('LL')
											: moment(rowData.createdAt).format('LL')
										return <span>{date}</span>
									}}
								/>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='createdBy'
									header='Kişi'
									sortable='true'
									style={{ width: '12rem' }}
									body={(rowData) => {
										const user = rowData.updatedBy || rowData.createdBy
										return <span>{user}</span>
									}}
								/>
								<Column
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='note'
									header='Not'
									style={{ width: 'auto', maxWidth: '300px' }}
									body={(rowData) => {
										return <span>{rowData.note}</span>
									}}
								/>
								<Column
									className='text-semi-bold'
									body={(rowData) => (
										<span className='d-flex gap-1'>{canDeleteOutsource && noteDeleteButtonTemplate(rowData)}</span>
									)}
									style={{ width: '2.5rem' }}
								/>
							</DataTable>
						</div>
					</div>
				) : (
					<div>
						<div className='card' style={{ display: 'flex', alignItems: 'center' }}>
							<div className='field w-100'>
								<InputTextarea
									name='note'
									className='input-border'
									placeholder='Not Giriniz'
									value={noteModal.form.note}
									onChange={(e) => handleNoteFormChange(e)}
									autoResize={false}
									rows={10}
									cols={50}
								/>
							</div>

							<Button className='btn-bill w-100' title='Kaydet' handleClick={handleNoteSubmit} />
							<Button
								className='btn-bill w-100'
								title='Vazgeç'
								handleClick={() => {
									setNoteModal((prev) => ({ ...prev, isEdit: false }))
								}}
							/>
						</div>
					</div>
				)}
			</Dialog>
		</>
	)
}

AddOutsourceModalContent.propTypes = {
	handleClose: PropTypes.func,
	handleAdd: PropTypes.func,
	outsourceId: PropTypes.number,
}

export default AddOutsourceModalContent
